import JahcrNoRightToWork from './JahcrNoRightToWork.component';

export default JahcrNoRightToWork;